import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { VideoBlock } from "../../../Shared/components/ContentBlocks/VideoBlock/VideoBlockLayout";
import { ResponsivePicture } from "../../../Shared/components/Image";
import { Block } from "./library/container";
export const RichTextBlock = (p)=>{
    const media = p.media != "none" && p.media.media.kind == "image" ? /*#__PURE__*/ _jsx("div", {
        className: "image-block__wrapper",
        children: /*#__PURE__*/ _jsx("div", {
            className: "image-block__inner",
            children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                imgClassName: "image-block__image",
                defaultImageUrl: p.media.media.imageUrlFallback,
                cropsPerMedia: [
                    {
                        crops: [
                            {
                                url: p.media.media.imageUrlSmall,
                                width: 400
                            },
                            {
                                url: p.media.media.imageUrl,
                                width: 800
                            },
                            {
                                url: p.media.media.imageUrlLarge,
                                width: 1600
                            }
                        ]
                    }
                ],
                width: 391,
                alt: p.media.media.imageAlt
            })
        })
    }) : p.media != "none" && p.media.media.kind == "video" ? /*#__PURE__*/ _jsx("div", {
        className: "video-block__wrapper",
        children: /*#__PURE__*/ _jsx("div", {
            className: "video-block__inner",
            children: /*#__PURE__*/ _jsx(VideoBlock, {
                ...p.media.media
            })
        })
    }) : null;
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: `richtext-block container--sg align--center${p.media != "none" ? ' richtext-block--media' : ' richtext-block--plain'}`,
            children: [
                p.title && /*#__PURE__*/ _jsx("h2", {
                    className: "richtext-block__title title--l",
                    children: p.title
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `richtext-block__media-container richtext-block__media-container--${p.media != "none" ? p.media.position : ""} `,
                    children: [
                        p.media != "none" && /*#__PURE__*/ _jsx("div", {
                            className: `richtext-block__media richtext-block__media--${p.media.position}`,
                            children: media
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: `richtext-block__container-buttons`,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: p.html
                                    },
                                    className: "richtext-block__container text--styled"
                                }),
                                (p.primaryActionTitle != "" || p.secondaryActionTitle != "") && /*#__PURE__*/ _jsxs("div", {
                                    className: "richtext-block__buttons",
                                    children: [
                                        p.primaryActionTitle != "" && /*#__PURE__*/ _jsx("a", {
                                            className: "button button--primary button--arrow",
                                            href: p.primaryActionUrl,
                                            children: p.primaryActionTitle
                                        }),
                                        p.secondaryActionTitle != "" && /*#__PURE__*/ _jsx("a", {
                                            className: "link link--primary link--arrow",
                                            href: p.secondaryActionUrl,
                                            children: p.secondaryActionTitle
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
{}